/**
 * @param {string} pathname_ state pathname
 * @param {string} hash_ state hash
 */
const RouterState = function (pathname_, hash_) {
	this.pathname = pathname_ || '';
	this.hash = hash_ || '';
	this.changes = [];
	this.init();
};

RouterState.URL_PARAM_SEPARATOR = '&';
RouterState.OPEN = 1;
RouterState.CLOSE = 0;

/**
 * Initializes the state. Detects necessary changes (i.e. differences between pathname and hash/page).
 */
RouterState.prototype.init = function () {
	this.hashObjects = this.parseHash(this.hash);

	Object.keys(this.hashObjects).forEach(key_ => {
		this.changes.push([key_, this.hashObjects[key_], RouterState.OPEN]);
	});
};

/**
 * Updates the state by the pages hash.
 * Detects necessary changes.
 * @param {Object} hash_ - the current hash
 */
RouterState.prototype.update = function (hash_) {
	const currentHashObjects = this.hashObjects;

	this.hash = hash_;
	this.hashObjects = this.parseHash(hash_);
	this.changes = [];

	// if we did not have it before: add the OPEN change
	Object.keys(this.hashObjects).forEach(key_ => {
		if (this.hashObjects[key_] !== currentHashObjects[key_]) {
			this.changes.push([key_, this.hashObjects[key_], RouterState.OPEN]);
		}
	});

	// if we had it and now it's gone: add the CLOSE change
	Object.keys(currentHashObjects).forEach(current => {
		if (!this.hashObjects[current]) {
			this.changes.push([current, currentHashObjects[current], RouterState.CLOSE]);
		}
	});
};

/**
 * Parses the hash_ to extract a key-value url parameter objects
 * @param {string} hash_ - hash part of the URL to be parsed
 * @returns {Object} key-value of url params
 */
RouterState.prototype.parseHash = function (hash_) {
	const urlParams = new Map();
	let hash = hash_ || '';

	// remove leading # from hash
	if (hash.match(/^#/)) {
		hash = hash.substring(1);
	}

	if (!!hash) {
		// taken with courtesy from http://stackoverflow.com/a/2880929/351423
		const search = /([^&=]+)=?([^&]*)/g; // this regex will extract the first GET-parameter key/value pair of a string
		const plusMatcher = /\+/g;

		// decodes the given hash part which is perhaps URLencoded
		const decode = search_ => decodeURIComponent(search_.replace(plusMatcher, ' '));

		let match;

		while ((match = search.exec(hash)) !== null) {
			const key = decode(match[1]);

			urlParams.set(key, decode(match[2]));
		}
	}

	return Object.fromEntries(urlParams);
};

/**
 * Returns and resets changes.
 * @returns {Array} changes before resetting: [channel ("layer"), value (path), 0/1 (close/open)]
 */
RouterState.prototype.getAndResetChanges = function () {
	const localChanges = this.changes;

	this.changes = [];
	return localChanges;
};

export {RouterState};
